import { render } from "./xsjjDetail.vue?vue&type=template&id=776c74d2&scoped=true&ts=true"
import script from "./xsjjDetail.vue?vue&type=script&lang=ts"
export * from "./xsjjDetail.vue?vue&type=script&lang=ts"

import "./xsjjDetail.vue?vue&type=style&index=0&id=776c74d2&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776c74d2"]])

export default __exports__